import { useBusinessContext } from '@root/context'
import { fetchContacts } from '@root/query/contacts'
import { keepPreviousData, useInfiniteQuery } from '@tanstack/react-query'

interface UseInfiniteContactsProps {
  search?: string
}

export const useInfiniteContacts = ({ search = '' }: UseInfiniteContactsProps = {}) => {
  const { slug } = useBusinessContext()

  return useInfiniteQuery({
    queryKey: [slug, 'contacts', { search }],
    initialPageParam: 1,
    queryFn: ({ pageParam = 1 }) =>
      fetchContacts({ slug }, { page: pageParam, search: search || undefined, page_size: 100 }),
    getNextPageParam: lastPage => lastPage.next,
    getPreviousPageParam: lastPage => lastPage.prev,
    staleTime: 60 * 1000,
    placeholderData: keepPreviousData
  })
}
